import { optionalNumber, optionalString, string, zodLess, ZodLessInfer } from '@kaiizen/zod-less';

// **************************************************************
// RetailerProduct API
// **************************************************************

export const RetailerProductSchema = zodLess({
  storeSkuId: optionalString,
  internetSkuId: optionalString.describe("The internet SKU ID of the product (For The Home Depot's, this is the OMS ID)"),
  title: optionalString,
  imageUrl: optionalString,
  description: optionalString,
  color: optionalString,
  price: optionalNumber,
  availability: optionalString,
  quantity: optionalNumber,
  productType: optionalString,
  brand: optionalString,
  productSupplierOrgId: optionalString.describe('The supplier Org to create the product under (catalog results only)'),
  supplierName: optionalString.describe('The supplier the catalog result comes from'),
}, {
  ref: 'retailerProduct',
  description: 'retailer product catalog data',
});
export type RetailerProduct = ZodLessInfer<typeof RetailerProductSchema>;

export const RetailerProductSearchRequestQuerySchema = zodLess({
  queryString: string,
  limit: optionalString,
}, { ref: 'retailerProductSearchRequestQuery' });
export type RetailerProductSearchRequestQuery = ZodLessInfer<typeof RetailerProductSearchRequestQuerySchema>;

// **************************************************************
// Combined Product Search API
// **************************************************************

export const CombinedProductSearchRequestQuerySchema = zodLess({
  queryString: string,
  limit: optionalString,
}, { ref: 'combinedProductSearchRequestQuery' });
export type CombinedProductSearchRequestQuery = ZodLessInfer<typeof CombinedProductSearchRequestQuerySchema>;

export const CombinedProductSearchResponseSchema = zodLess({
  id: optionalString,
  orgId: optionalString,
  storeSkuId: optionalString,
  internetSkuId: optionalString.describe("The internet SKU ID of the product (For The Home Depot's, this is the OMS ID)"),
  title: optionalString,
  imageUrl: optionalString,
  description: optionalString,
  color: optionalString,
  price: optionalNumber,
  availability: optionalString,
  quantity: optionalNumber,
  productType: optionalString,
  brand: optionalString,
  productSupplierOrgId: optionalString.describe('The supplier Org to create the product under (catalog results only)'),
  supplierName: optionalString.describe(
    "The supplier the result comes from: a catalog result's supplier, or the supplier text an org product was entered with",
  ),
}, {
  ref: 'combinedProductSearchResponse',
  description: 'Combined product search result (retailer and organization products)',
});
export type CombinedProductSearchResponse = ZodLessInfer<typeof CombinedProductSearchResponseSchema>;
